import { NavigationButton } from 'Components/_theme'

import { Heading } from '../Heading/Heading'
import { PRESENTATION_ITEM } from './NavigationButton.constants'

export const NavigationButtonPresentation = () => {
  const toggleMenuVisibility = () => {}

  return (
    <div>
      <Heading size={4}> Navigation Buttons:</Heading>

      <div className="d-flex pt-4 justify-content-evenly">
        {/* *** Active Navigation Button  *** */}

        <NavigationButton
          isActive
          isCompact={false}
          item={PRESENTATION_ITEM}
          toggleMenuVisibility={toggleMenuVisibility}
        />

        {/* *** Inactive Navigation Button  *** */}

        <NavigationButton
          isActive={false}
          isCompact={false}
          item={PRESENTATION_ITEM}
          toggleMenuVisibility={toggleMenuVisibility}
        />

        {/* *** Inactive Compact Navigation Button  *** */}

        <NavigationButton
          isActive
          isCompact
          item={PRESENTATION_ITEM}
          toggleMenuVisibility={toggleMenuVisibility}
        />

        {/* *** Active Compact Navigation Button  *** */}

        <NavigationButton
          isActive={false}
          isCompact
          item={PRESENTATION_ITEM}
          toggleMenuVisibility={toggleMenuVisibility}
        />
      </div>
    </div>
  )
}
